<template>
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-row-dashed">
      <thead>
      <tr class="text-center fw-bolder">
        <th scope="col">#</th>
        <th scope="col">Data</th>
        <th scope="col">Canal</th>
        <th scope="col">Destino</th>
        <th scope="col">Aviso</th>
        <th scope="col">Situação</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="loading">
        <td colspan="12" class="text-center text-muted">Carregando avisos...</td>
      </tr>
      <tr v-else-if="messages.length < 1">
        <td colspan="12" class="text-center">
          Nenhum aviso enviado.
        </td>
      </tr>
      </tbody>
      <tbody :key="message.id_spm" v-for="message in messages" class="text-center">
      <tr>
        <td>
          <button class="btn btn-sm btn-outline btn-outline-secondary"
                  type="button" data-bs-toggle="collapse" v-if="(message.statuses?.length ?? 0) > 0"
                  :data-bs-target="'#subTableProgramMessage-' + message.id_spm" aria-expanded="false"
                  aria-controls="collapseExample">
            <i class="bi bi-plus-circle"></i>
          </button>
        </td>
        <td>{{ this.date(message.spm_sent_at).format('DD/MM/YYYY HH:mm') }}</td>
        <td>{{ message.channel }}</td>
        <td>
          {{ message.spm_channel === 'whatsapp' ? maskIt(message.spm_to, '(##) #####-####') : message.spm_to }}
        </td>
        <td>
          {{ message.type }}
          <span class="text-muted fs-8 d-block" v-if="message.spm_remaining != null">
            {{ message.spm_remaining }} sessão(ões) restante(s)
          </span>
        </td>
        <td>
          <span class="badge badge-light-danger" v-if="message.spm_error" :title="message.spm_error">
            Falhou
          </span>
          <span class="badge badge-light-success" v-else>
            {{ lastStatus(message) }}
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="12" class="p-0">
          <div :id="'subTableProgramMessage-' + message.id_spm" class="collapse">
            <hr>
            <h4 class="text-center">Histórico</h4>
            <hr>
            <table class="table table-bordered border-primary">
              <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody v-for="status in message.statuses">
              <tr>
                <td>{{ status.received_at != null ? this.date(status.received_at).format('DD/MM/YYYY HH:mm') : '-' }}</td>
                <td>{{ status.status_dsc || status.status }}</td>
              </tr>
              </tbody>
            </table>
            <div class="alert alert-danger mx-4" v-if="message.spm_error">
              {{ message.spm_error }}
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import strMask from "../../helpers/strMask";
import http from "../../helpers/http";

export default {
  name: "ScheduleProgramMessageTable",
  props: ['programId', 'uniqueKey'],
  data() {
    return {
      messages: [],
      loading: false,
    }
  },
  watch: {
    programId() {
      this.getProgramMessages();
    },
    uniqueKey() {
      this.getProgramMessages();
    },
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.getProgramMessages();
  },
  methods: {
    date: moment,
    maskIt(value, mask) {
      return strMask.it(value, mask);
    },
    lastStatus(message) {
      return message.statuses?.[0]?.status_dsc ?? 'Enviado';
    },
    getProgramMessages() {
      if (!this.programId || !this.place?.id_place)
        return;

      this.loading = true;
      http.get(`/places/${this.place.id_place}/schedules/programs/${this.programId}/messages`)
        .then((response) => {
          this.messages = response.data ?? [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>

<style scoped>

</style>
